var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-item dd-item--has-img"},[_c('span',[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),(_vm.item.image)?_c('img',{attrs:{"src":_vm.item.image.thumb,"alt":_vm.item.name}}):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ded000","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/search/itemTemplate.vue
// module id = 272
// module chunks = 2 3